// // import React from "react";
// // import axios from "axios";
// // import { useEffect, useState } from "react";
// // import { API_BASE_URL } from "../utils";
// // import {
// //     Box,
// //     Typography,
// //     Paper,
// //     Table,
// //     TableBody,
// //     TableCell,
// //     TableContainer,
// //     TableHead,
// //     TableRow,
// //     Chip,
// //     Avatar,
// //     Button,
// //     Dialog,
// //     DialogTitle,
// //     DialogContent,
// //     DialogActions,
// //     Divider,
// //     Grid,
// //     Card,
// //     CardContent,
// //     CardMedia,
// //     List,
// //     ListItem,
// //     ListItemText,
// //     IconButton,
// //     Tooltip,
// //     TextField,
// //     InputAdornment,
// //     TablePagination,
// //     CircularProgress,
// //     Badge,
// // } from "@mui/material";
// // import {
// //     PendingActions,
// //     CheckCircle,
// //     Close,
// //     Email,
// //     Phone,
// //     Person,
// //     Inventory,
// //     Description,
// //     Search,
// //     FilterList,
// //     Refresh,
// //     ArrowForward,
// //     Business,
// //     LocalShipping,
// //     AttachMoney,
// //     CalendarToday,
// // } from "@mui/icons-material";

// // export function Enquiries() {
// //     // State management
// //     const [enquiries, setEnquiries] = useState([]);
// //     const [filteredEnquiries, setFilteredEnquiries] = useState([]);
// //     const [selectedEnquiry, setSelectedEnquiry] = useState(null);
// //     const [openDialog, setOpenDialog] = useState(false);
// //     const [loading, setLoading] = useState(true);
// //     const [searchTerm, setSearchTerm] = useState("");
// //     const [page, setPage] = useState(0);
// //     const [rowsPerPage, setRowsPerPage] = useState(10);

// //     // Fetch data from API
// //     const fetchData = async () => {
// //         setLoading(true);
// //         try {
// //             const header = localStorage.getItem("adminId");
// //             const headers = { Authorization: `Bearer ${header}` };
// //             const response = await axios.get(`${API_BASE_URL}/admin/vendor/enquiries`, { headers });

// //             if (response.data.success) {
// //                 setEnquiries(response.data.enquiries);
// //                 setFilteredEnquiries(response.data.enquiries);
// //             }
// //         } catch (error) {
// //             console.error("Error fetching enquiries:", error);
// //         } finally {
// //             setLoading(false);
// //         }
// //     };
// //     const UpdatedSTatus = async () => {
// //         setLoading(true);
// //         try {
// //             const header = localStorage.getItem("adminId");
// //             const headers = { Authorization: `Bearer ${header}` };
// //             const response = await axios.put(`${API_BASE_URL}/admin/vendor/enquiries`, { headers });

// //             if (response.data.success) {
// //                 setEnquiries(response.data.enquiries);
// //                 setFilteredEnquiries(response.data.enquiries);
// //             }
// //         } catch (error) {
// //             console.error("Error fetching enquiries:", error);
// //         } finally {
// //             setLoading(false);
// //         }
// //     };

// //     // Filter enquiries based on search term
// //     const handleSearch = (term) => {
// //         setSearchTerm(term);
// //         if (term === "") {
// //             setFilteredEnquiries(enquiries);
// //         } else {
// //             const filtered = enquiries.filter(
// //                 (enquiry) =>
// //                     enquiry.name.toLowerCase().includes(term.toLowerCase()) ||
// //                     enquiry.email.toLowerCase().includes(term.toLowerCase()) ||
// //                     enquiry.product.product.toLowerCase().includes(term.toLowerCase()) ||
// //                     enquiry.product.partNumber.toLowerCase().includes(term.toLowerCase()) ||
// //                     enquiry.status.toLowerCase().includes(term.toLowerCase())
// //             );
// //             setFilteredEnquiries(filtered);
// //         }
// //     };

// //     // Handle pagination
// //     const handleChangePage = (event, newPage) => {
// //         setPage(newPage);
// //     };

// //     const handleChangeRowsPerPage = (event) => {
// //         setRowsPerPage(parseInt(event.target.value, 10));
// //         setPage(0);
// //     };

// //     // View details handler
// //     const handleViewDetails = (enquiry) => {
// //         setSelectedEnquiry(enquiry);
// //         setOpenDialog(true);
// //     };

// //     // Close dialog
// //     const handleCloseDialog = () => {
// //         setOpenDialog(false);
// //     };

// //     // Status chip component
// //     const StatusChip = ({ status }) => {
// //         const statusConfig = {
// //             PENDING: { icon: <PendingActions />, label: "Pending", color: "warning" },
// //             APPROVED: { icon: <CheckCircle />, label: "Approved", color: "success" },
// //             REJECTED: { icon: <Close />, label: "Rejected", color: "error" },
// //         };

// //         const config = statusConfig[status] || {
// //             icon: null,
// //             label: status,
// //             color: "default"
// //         };

// //         return (
// //             <Chip
// //                 icon={config.icon}
// //                 label={config.label}
// //                 color={config.color}
// //                 variant="outlined"
// //                 size="small"
// //             />
// //         );
// //     };

// //     // Format date
// //     const formatDate = (dateString) => {
// //         const options = { year: 'numeric', month: 'short', day: 'numeric' };
// //         return new Date(dateString).toLocaleDateString(undefined, options);
// //     };

// //     useEffect(() => {
// //         fetchData();
// //     }, []);

// //     return (
// //         <Box sx={{ p: 3 }}>
// //             {/* Page Header */}
// //             <Box sx={{
// //                 display: 'flex',
// //                 justifyContent: 'space-between',
// //                 alignItems: 'center',
// //                 mb: 3
// //             }}>
// //                 <Typography variant="h5" component="h1" fontWeight="fontWeightBold">
// //                     Product Enquiries
// //                 </Typography>
// //                 <Box>
// //                     <Tooltip title="Refresh">
// //                         <IconButton onClick={fetchData} color="primary">
// //                             <Refresh />
// //                         </IconButton>
// //                     </Tooltip>
// //                 </Box>
// //             </Box>

// //             {/* Main Content */}
// //             {loading ? (
// //                 <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
// //                     <CircularProgress />
// //                 </Box>
// //             ) : (
// //                 <>
// //                     <TableContainer component={Paper}>
// //                         <Table sx={{ minWidth: 650 }} aria-label="enquiries table">
// //                             <TableHead>
// //                                 <TableRow>
// //                                     <TableCell>Product</TableCell>
// //                                     <TableCell>Customer</TableCell>
// //                                     <TableCell align="center">Quantity</TableCell>
// //                                     <TableCell align="center">Vendor Name</TableCell>
// //                                     <TableCell align="center">Vendor Email</TableCell>
// //                                     <TableCell align="center">Date</TableCell>
// //                                     <TableCell align="center">Status</TableCell>
// //                                     <TableCell align="right">Actions</TableCell>
// //                                 </TableRow>
// //                             </TableHead>
// //                             <TableBody>
// //                                 {filteredEnquiries
// //                                     .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
// //                                     .map((enquiry) => (
// //                                         <TableRow key={enquiry._id} hover>
// //                                             <TableCell>
// //                                                 <Box sx={{ display: "flex", alignItems: "center" }}>
// //                                                     <Avatar
// //                                                         src={enquiry.product.productimages[0]?.productimage}
// //                                                         variant="rounded"
// //                                                         sx={{ width: 40, height: 40, mr: 2 }}
// //                                                     />
// //                                                     <Box>
// //                                                         <Typography variant="body1" fontWeight="500">
// //                                                             {enquiry.product.product}
// //                                                         </Typography>
// //                                                         <Typography variant="body2" color="text.secondary">
// //                                                             Part #: {enquiry.product.partNumber}
// //                                                         </Typography>
// //                                                     </Box>
// //                                                 </Box>
// //                                             </TableCell>
// //                                             <TableCell>
// //                                                 <Typography variant="body1">{enquiry.name}</Typography>
// //                                                 <Typography variant="body2" color="text.secondary">
// //                                                     {enquiry.email}
// //                                                 </Typography>
// //                                             </TableCell>
// //                                             <TableCell align="center">
// //                                                 {console.log(enquiry, "enquiry")}
// //                                                 <Chip
// //                                                     label={enquiry.quantity}
// //                                                     variant="outlined"
// //                                                     size="small"
// //                                                 />
// //                                             </TableCell>
// //                                             <TableCell align="center">
// //                                                 <Chip
// //                                                     label={`${enquiry?.vendor?.firstName} ${enquiry?.vendor?.lastName}`}
// //                                                     variant="outlined"
// //                                                     size="small"
// //                                                 />
// //                                             </TableCell>
// //                                             <TableCell align="center">
// //                                                 <Chip
// //                                                     label={enquiry?.vendor?.email}
// //                                                     variant="outlined"
// //                                                     size="small"
// //                                                 />
// //                                             </TableCell>
// //                                             <TableCell align="center">
// //                                                 {formatDate(enquiry.createdAt)}
// //                                             </TableCell>
// //                                             <TableCell align="center">
// //                                                 <StatusChip status={enquiry.status} />
// //                                             </TableCell>
// //                                             <TableCell align="center">
// //                                                 <ArrowForward onClick={() => handleViewDetails(enquiry)} />
// //                                             </TableCell>
// //                                         </TableRow>
// //                                     ))}
// //                             </TableBody>
// //                         </Table>
// //                     </TableContainer>

// //                     <TablePagination
// //                         rowsPerPageOptions={[5, 10, 25]}
// //                         component="div"
// //                         count={filteredEnquiries.length}
// //                         rowsPerPage={rowsPerPage}
// //                         page={page}
// //                         onPageChange={handleChangePage}
// //                         onRowsPerPageChange={handleChangeRowsPerPage}
// //                         sx={{ mt: 2 }}
// //                     />
// //                 </>
// //             )}

// //             {/* Enquiry Details Dialog */}
// <Dialog
//     open={openDialog}
//     onClose={handleCloseDialog}
//     maxWidth="md"
//     fullWidth
//     scroll="paper"
// >
//     <DialogTitle sx={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         borderBottom: '1px solid',
//         borderColor: 'divider',
//         pb: 2
//     }}>
//         <Box>
//             <Typography variant="h6">Enquiry Details</Typography>
//             <Typography variant="body2" color="text.secondary">
//                 ID: {selectedEnquiry?._id}
//             </Typography>
//         </Box>
//         <StatusChip status={selectedEnquiry?.status} />
//     </DialogTitle>
//     <DialogContent dividers>
//         {selectedEnquiry && (
//             <Grid container spacing={3}>
//                 {/* Product Information Column */}
//                 <Grid item xs={12} md={6}>
//                     <Card variant="outlined" sx={{ mb: 3 }}>
//                         <CardMedia
//                             component="img"
//                             height="200"
//                             image={selectedEnquiry.product.productimages[0]?.productimage}
//                             alt={selectedEnquiry.product.product}
//                             sx={{ objectFit: 'contain', p: 2 }}
//                         />
//                         <CardContent>
//                             <Typography gutterBottom variant="h6" component="div">
//                                 {selectedEnquiry.product.product}
//                             </Typography>

//                             <Grid container spacing={1} sx={{ mb: 2 }}>
//                                 <Grid item xs={6}>
//                                     <Typography variant="body2" color="text.secondary">
//                                         <Box component="span" fontWeight="fontWeightMedium">Part #:</Box> {selectedEnquiry.product.partNumber}
//                                     </Typography>
//                                 </Grid>
//                                 <Grid item xs={6}>
//                                     <Typography variant="body2" color="text.secondary">
//                                         <Box component="span" fontWeight="fontWeightMedium">Manufacturer:</Box> {selectedEnquiry.product.manufacturer}
//                                     </Typography>
//                                 </Grid>
//                                 <Grid item xs={6}>
//                                     <Typography variant="body2" color="text.secondary">
//                                         <Box component="span" fontWeight="fontWeightMedium">Available:</Box> {selectedEnquiry.product.quantity}
//                                     </Typography>
//                                 </Grid>
//                                 <Grid item xs={6}>
//                                     <Typography variant="body2" color="text.secondary">
//                                         <Box component="span" fontWeight="fontWeightMedium">Price:</Box> ₹{selectedEnquiry.product.Productprice}
//                                     </Typography>
//                                 </Grid>
//                             </Grid>

//                             <Divider sx={{ my: 2 }} />

//                             <Typography variant="subtitle1" gutterBottom>
//                                 Product Specifications
//                             </Typography>
//                             <List dense disablePadding>
//                                 {selectedEnquiry.product.descriptions.map((desc, index) => (
//                                     <ListItem key={index} disableGutters>
//                                         <ListItemText
//                                             primary={desc.name}
//                                             secondary={desc.value}
//                                             primaryTypographyProps={{ variant: 'body2' }}
//                                             secondaryTypographyProps={{ variant: 'body2', color: 'text.primary' }}
//                                         />
//                                     </ListItem>
//                                 ))}
//                             </List>
//                         </CardContent>
//                     </Card>
//                 </Grid>

//                 {/* Customer and Enquiry Information Column */}
//                 <Grid item xs={12} md={6}>
//                     <Card variant="outlined" sx={{ mb: 3 }}>
//                         <CardContent>
//                             <Typography variant="subtitle1" gutterBottom>
//                                 Customer Information
//                             </Typography>
//                             <List dense disablePadding>
//                                 <ListItem disableGutters>
//                                     <ListItemText
//                                         primary={
//                                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                                 <Person color="primary" sx={{ mr: 1 }} />
//                                                 <Typography variant="body1">
//                                                     {selectedEnquiry.name}
//                                                 </Typography>
//                                             </Box>
//                                         }
//                                     />
//                                 </ListItem>
//                                 <ListItem disableGutters>
//                                     <ListItemText
//                                         primary={
//                                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                                 <Email color="primary" sx={{ mr: 1 }} />
//                                                 <Typography variant="body1">
//                                                     {selectedEnquiry.email}
//                                                 </Typography>
//                                             </Box>
//                                         }
//                                     />
//                                 </ListItem>
//                                 <ListItem disableGutters>
//                                     <ListItemText
//                                         primary={
//                                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                                 <Phone color="primary" sx={{ mr: 1 }} />
//                                                 <Typography variant="body1">
//                                                     {selectedEnquiry.phone}
//                                                 </Typography>
//                                             </Box>
//                                         }
//                                     />
//                                 </ListItem>
//                             </List>

//                             <Divider sx={{ my: 2 }} />

//                             <Typography variant="subtitle1" gutterBottom>
//                                 Enquiry Details
//                             </Typography>
//                             <List dense disablePadding>
//                                 <ListItem disableGutters>
//                                     <ListItemText
//                                         primary={
//                                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                                 <Inventory color="primary" sx={{ mr: 1 }} />
//                                                 <Typography variant="body1">
//                                                     Requested Quantity: {selectedEnquiry.quantity}
//                                                 </Typography>
//                                             </Box>
//                                         }
//                                     />
//                                 </ListItem>
//                                 <ListItem disableGutters>
//                                     <ListItemText
//                                         primary={
//                                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                                 <AttachMoney color="primary" sx={{ mr: 1 }} />
//                                                 <Typography variant="body1">
//                                                     Total Value: ₹{selectedEnquiry.quantity * selectedEnquiry.product.Productprice}
//                                                 </Typography>
//                                             </Box>
//                                         }
//                                     />
//                                 </ListItem>
//                                 <ListItem disableGutters>
//                                     <ListItemText
//                                         primary={
//                                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                                 <CalendarToday color="primary" sx={{ mr: 1 }} />
//                                                 <Typography variant="body1">
//                                                     Enquiry Date: {formatDate(selectedEnquiry.createdAt)}
//                                                 </Typography>
//                                             </Box>
//                                         }
//                                     />
//                                 </ListItem>
//                                 <ListItem disableGutters>
//                                     <ListItemText
//                                         primary="Message:"
//                                         secondary={selectedEnquiry.message}
//                                         secondaryTypographyProps={{ color: 'text.primary' }}
//                                     />
//                                 </ListItem>
//                             </List>

//                             <Divider sx={{ my: 2 }} />

//                             <Typography variant="subtitle1" gutterBottom>
//                                 Vendor Information
//                             </Typography>
//                             <List dense disablePadding>
//                                 <ListItem disableGutters>
//                                     <ListItemText
//                                         primary={
//                                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                                 <Business color="primary" sx={{ mr: 1 }} />
//                                                 <Typography variant="body1">
//                                                     {selectedEnquiry.vendor.companyName}
//                                                 </Typography>
//                                             </Box>
//                                         }
//                                         secondary={selectedEnquiry.vendor.registeredAddress}
//                                     />
//                                 </ListItem>
//                                 <ListItem disableGutters>
//                                     <ListItemText
//                                         primary={
//                                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                                 <LocalShipping color="primary" sx={{ mr: 1 }} />
//                                                 <Typography variant="body1">
//                                                     {selectedEnquiry.vendor.country}
//                                                 </Typography>
//                                             </Box>
//                                         }
//                                         secondary={`GSTIN: ${selectedEnquiry.vendor.GSTIN}`}
//                                     />
//                                 </ListItem>
//                             </List>
//                         </CardContent>
//                     </Card>
//                 </Grid>
//             </Grid>
//         )}
//     </DialogContent>
//     <DialogActions sx={{ p: 2, borderTop: '1px solid', borderColor: 'divider' }}>
//         <Button onClick={handleCloseDialog} variant="outlined">
//             Close
//         </Button>
//     </DialogActions>
// </Dialog>
// //         </Box>
// //     );
// // }
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//     Box,
//     Typography,
//     Paper,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Chip,
//     Avatar,
//     Button,
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     Divider,
//     Grid,
//     Card,
//     CardContent,
//     CardMedia,
//     List,
//     ListItem,
//     ListItemText,
//     IconButton,
//     Tooltip,
//     TablePagination,
//     CircularProgress,
// } from "@mui/material";
// import {
//     PendingActions,
//     CheckCircle,
//     Close,
//     Email,
//     Phone,
//     Person,
//     Inventory,
//     Description,
//     Search,
//     FilterList,
//     Refresh,
//     ArrowForward,
//     Business,
//     LocalShipping,
//     AttachMoney,
//     CalendarToday,
// } from "@mui/icons-material";
// import { API_BASE_URL } from "../utils";

// export function Enquiries() {
//     const [enquiries, setEnquiries] = useState([]);
//     const [filteredEnquiries, setFilteredEnquiries] = useState([]);
//     const [selectedEnquiry, setSelectedEnquiry] = useState(null);
//     const [openDialog, setOpenDialog] = useState(false);
//     const [loading, setLoading] = useState(true);
//     const [searchTerm, setSearchTerm] = useState("");
//     const [page, setPage] = useState(0);
//     const [rowsPerPage, setRowsPerPage] = useState(10);

//     const statusOptions = ["PENDING", "APPROVED", "REJECTED", "CLOSED"];

//     const fetchData = async () => {
//         setLoading(true);
//         try {
//             const header = localStorage.getItem("adminId");
//             const headers = { Authorization: `Bearer ${header}` };
//             const response = await axios.get(`${API_BASE_URL}/admin/vendor/enquiries`, { headers });
//             if (response.data.success) {
//                 setEnquiries(response.data.enquiries);
//                 setFilteredEnquiries(response.data.enquiries);
//             }
//         } catch (error) {
//             console.error("Error fetching enquiries:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const updateEnquiryStatus = async (enquiryId, newStatus) => {
//         setLoading(true);
//         try {
//             const header = localStorage.getItem("adminId");
//             const headers = { Authorization: `Bearer ${header}` };
//             const response = await axios.put(
//                 `${API_BASE_URL}/admin/vendor/enquiries/${enquiryId}/status`,
//                 { status: newStatus },
//                 { headers }
//             );

//             if (response.data.success) {
//                 setEnquiries(prevEnquiries =>
//                     prevEnquiries.map(enquiry =>
//                         enquiry._id === enquiryId ? { ...enquiry, status: newStatus } : enquiry
//                     )
//                 );
//                 setFilteredEnquiries(prevEnquiries =>
//                     prevEnquiries.map(enquiry =>
//                         enquiry._id === enquiryId ? { ...enquiry, status: newStatus } : enquiry
//                     )
//                 );
//             }
//         } catch (error) {
//             console.error("Error updating enquiry status:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleSearch = (term) => {
//         setSearchTerm(term);
//         if (term === "") {
//             setFilteredEnquiries(enquiries);
//         } else {
//             const filtered = enquiries.filter(
//                 (enquiry) =>
//                     enquiry.name.toLowerCase().includes(term.toLowerCase()) ||
//                     enquiry.email.toLowerCase().includes(term.toLowerCase()) ||
//                     enquiry.product.product.toLowerCase().includes(term.toLowerCase()) ||
//                     enquiry.product.partNumber.toLowerCase().includes(term.toLowerCase()) ||
//                     enquiry.status.toLowerCase().includes(term.toLowerCase())
//             );
//             setFilteredEnquiries(filtered);
//         }
//     };

//     const handleChangePage = (event, newPage) => {
//         setPage(newPage);
//     };

//     const handleChangeRowsPerPage = (event) => {
//         setRowsPerPage(parseInt(event.target.value, 10));
//         setPage(0);
//     };

//     const handleViewDetails = (enquiry) => {
//         setSelectedEnquiry(enquiry);
//         setOpenDialog(true);
//     };

//     const handleCloseDialog = () => {
//         setOpenDialog(false);
//     };

//     const StatusChip = ({ status }) => {
//         const statusConfig = {
//             PENDING: { icon: <PendingActions />, label: "Pending", color: "warning" },
//             APPROVED: { icon: <CheckCircle />, label: "Approved", color: "success" },
//             REJECTED: { icon: <Close />, label: "Rejected", color: "error" },
//             CLOSED: { icon: <Close />, label: "Closed", color: "default" },
//         };
//         const config = statusConfig[status] || {
//             icon: null,
//             label: status,
//             color: "default"
//         };
//         return (
//             <Chip
//                 icon={config.icon}
//                 label={config.label}
//                 color={config.color}
//                 variant="outlined"
//                 size="small"
//             />
//         );
//     };

//     const formatDate = (dateString) => {
//         const options = { year: 'numeric', month: 'short', day: 'numeric' };
//         return new Date(dateString).toLocaleDateString(undefined, options);
//     };

//     useEffect(() => {
//         fetchData();
//     }, []);

//     return (
//         <Box sx={{ p: 3 }}>
//             <Box sx={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 mb: 3
//             }}>
//                 <Typography variant="h5" component="h1" fontWeight="fontWeightBold">
//                     Product Enquiries
//                 </Typography>
//                 <Box>
//                     <Tooltip title="Refresh">
//                         <IconButton onClick={fetchData} color="primary">
//                             <Refresh />
//                         </IconButton>
//                     </Tooltip>
//                 </Box>
//             </Box>

//             {loading ? (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
//                     <CircularProgress />
//                 </Box>
//             ) : (
//                 <>
//                     <TableContainer component={Paper}>
//                         <Table sx={{ minWidth: 650 }} aria-label="enquiries table">
//                             <TableHead>
//                                 <TableRow>
//                                     <TableCell>Product</TableCell>
//                                     <TableCell>Customer</TableCell>
//                                     <TableCell align="center">Quantity</TableCell>
//                                     <TableCell align="center">Vendor Name</TableCell>
//                                     <TableCell align="center">Vendor Email</TableCell>
//                                     <TableCell align="center">Date</TableCell>
//                                     <TableCell align="center">Status</TableCell>
//                                     <TableCell align="right">Actions</TableCell>
//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>
//                                 {filteredEnquiries
//                                     .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                                     .map((enquiry) => (
//                                         <TableRow key={enquiry._id} hover>
//                                             <TableCell>
//                                                 <Box sx={{ display: "flex", alignItems: "center" }}>
//                                                     <Avatar
//                                                         src={enquiry.product.productimages[0]?.productimage}
//                                                         variant="rounded"
//                                                         sx={{ width: 40, height: 40, mr: 2 }}
//                                                     />
//                                                     <Box>
//                                                         <Typography variant="body1" fontWeight="500">
//                                                             {enquiry.product.product}
//                                                         </Typography>
//                                                         <Typography variant="body2" color="text.secondary">
//                                                             Part #: {enquiry.product.partNumber}
//                                                         </Typography>
//                                                     </Box>
//                                                 </Box>
//                                             </TableCell>
//                                             <TableCell>
//                                                 <Typography variant="body1">{enquiry.name}</Typography>
//                                                 <Typography variant="body2" color="text.secondary">
//                                                     {enquiry.email}
//                                                 </Typography>
//                                             </TableCell>
//                                             <TableCell align="center">
//                                                 <Chip
//                                                     label={enquiry.quantity}
//                                                     variant="outlined"
//                                                     size="small"
//                                                 />
//                                             </TableCell>
//                                             <TableCell align="center">
//                                                 <Chip
//                                                     label={`${enquiry?.vendor?.firstName} ${enquiry?.vendor?.lastName}`}
//                                                     variant="outlined"
//                                                     size="small"
//                                                 />
//                                             </TableCell>
//                                             <TableCell align="center">
//                                                 <Chip
//                                                     label={enquiry?.vendor?.email}
//                                                     variant="outlined"
//                                                     size="small"
//                                                 />
//                                             </TableCell>
//                                             <TableCell align="center">
//                                                 {formatDate(enquiry.createdAt)}
//                                             </TableCell>
//                                             <TableCell align="center">
//                                                 <StatusChip status={enquiry.status} />
//                                             </TableCell>
//                                             <TableCell align="center">
//                                                 <IconButton onClick={() => handleViewDetails(enquiry)}>
//                                                     <ArrowForward />
//                                                 </IconButton>
//                                             </TableCell>
//                                         </TableRow>
//                                     ))}
//                             </TableBody>
//                         </Table>
//                     </TableContainer>
//                     <TablePagination
//                         rowsPerPageOptions={[5, 10, 25]}
//                         component="div"
//                         count={filteredEnquiries.length}
//                         rowsPerPage={rowsPerPage}
//                         page={page}
//                         onPageChange={handleChangePage}
//                         onRowsPerPageChange={handleChangeRowsPerPage}
//                         sx={{ mt: 2 }}
//                     />
//                 </>
//             )}

//             <Dialog
//                 open={openDialog}
//                 onClose={handleCloseDialog}
//                 maxWidth="md"
//                 fullWidth
//                 scroll="paper"
//             >
//                 <DialogTitle sx={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     borderBottom: '1px solid',
//                     borderColor: 'divider',
//                     pb: 2
//                 }}>
//                     <Box>
//                         <Typography variant="h6">Enquiry Details</Typography>
//                         <Typography variant="body2" color="text.secondary">
//                             ID: {selectedEnquiry?._id}
//                         </Typography>
//                     </Box>
//                     <StatusChip status={selectedEnquiry?.status} />
//                 </DialogTitle>
//                 <DialogContent dividers>
//                     {selectedEnquiry && (
//                         <Grid container spacing={3}>
//                             <Grid item xs={12} md={6}>
//                                 <Card variant="outlined" sx={{ mb: 3 }}>
//                                     <CardMedia
//                                         component="img"
//                                         height="200"
//                                         image={selectedEnquiry.product.productimages[0]?.productimage}
//                                         alt={selectedEnquiry.product.product}
//                                         sx={{ objectFit: 'contain', p: 2 }}
//                                     />
//                                     <CardContent>
//                                         <Typography gutterBottom variant="h6" component="div">
//                                             {selectedEnquiry.product.product}
//                                         </Typography>
//                                         <Grid container spacing={1} sx={{ mb: 2 }}>
//                                             <Grid item xs={6}>
//                                                 <Typography variant="body2" color="text.secondary">
//                                                     <Box component="span" fontWeight="fontWeightMedium">Part #:</Box> {selectedEnquiry.product.partNumber}
//                                                 </Typography>
//                                             </Grid>
//                                             <Grid item xs={6}>
//                                                 <Typography variant="body2" color="text.secondary">
//                                                     <Box component="span" fontWeight="fontWeightMedium">Manufacturer:</Box> {selectedEnquiry.product.manufacturer}
//                                                 </Typography>
//                                             </Grid>
//                                             <Grid item xs={6}>
//                                                 <Typography variant="body2" color="text.secondary">
//                                                     <Box component="span" fontWeight="fontWeightMedium">Available:</Box> {selectedEnquiry.product.quantity}
//                                                 </Typography>
//                                             </Grid>
//                                             <Grid item xs={6}>
//                                                 <Typography variant="body2" color="text.secondary">
//                                                     <Box component="span" fontWeight="fontWeightMedium">Price:</Box> ₹{selectedEnquiry.product.Productprice}
//                                                 </Typography>
//                                             </Grid>
//                                         </Grid>
//                                         <Divider sx={{ my: 2 }} />
//                                         <Typography variant="subtitle1" gutterBottom>
//                                             Product Specifications
//                                         </Typography>
//                                         <List dense disablePadding>
//                                             {selectedEnquiry.product.descriptions.map((desc, index) => (
//                                                 <ListItem key={index} disableGutters>
//                                                     <ListItemText
//                                                         primary={desc.name}
//                                                         secondary={desc.value}
//                                                         primaryTypographyProps={{ variant: 'body2' }}
//                                                         secondaryTypographyProps={{ variant: 'body2', color: 'text.primary' }}
//                                                     />
//                                                 </ListItem>
//                                             ))}
//                                         </List>
//                                     </CardContent>
//                                 </Card>
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <Card variant="outlined" sx={{ mb: 3 }}>
//                                     <CardContent>
//                                         <Typography variant="subtitle1" gutterBottom>
//                                             Customer Information
//                                         </Typography>
//                                         <List dense disablePadding>
//                                             <ListItem disableGutters>
//                                                 <ListItemText
//                                                     primary={
//                                                         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                                             <Person color="primary" sx={{ mr: 1 }} />
//                                                             <Typography variant="body1">
//                                                                 {selectedEnquiry.name}
//                                                             </Typography>
//                                                         </Box>
//                                                     }
//                                                 />
//                                             </ListItem>
//                                             <ListItem disableGutters>
//                                                 <ListItemText
//                                                     primary={
//                                                         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                                             <Email color="primary" sx={{ mr: 1 }} />
//                                                             <Typography variant="body1">
//                                                                 {selectedEnquiry.email}
//                                                             </Typography>
//                                                         </Box>
//                                                     }
//                                                 />
//                                             </ListItem>
//                                             <ListItem disableGutters>
//                                                 <ListItemText
//                                                     primary={
//                                                         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                                             <Phone color="primary" sx={{ mr: 1 }} />
//                                                             <Typography variant="body1">
//                                                                 {selectedEnquiry.phone}
//                                                             </Typography>
//                                                         </Box>
//                                                     }
//                                                 />
//                                             </ListItem>
//                                         </List>
//                                         <Divider sx={{ my: 2 }} />
//                                         <Typography variant="subtitle1" gutterBottom>
//                                             Enquiry Details
//                                         </Typography>
//                                         <List dense disablePadding>
//                                             <ListItem disableGutters>
//                                                 <ListItemText
//                                                     primary={
//                                                         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                                             <Inventory color="primary" sx={{ mr: 1 }} />
//                                                             <Typography variant="body1">
//                                                                 Requested Quantity: {selectedEnquiry.quantity}
//                                                             </Typography>
//                                                         </Box>
//                                                     }
//                                                 />
//                                             </ListItem>
//                                             <ListItem disableGutters>
//                                                 <ListItemText
//                                                     primary={
//                                                         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                                             <AttachMoney color="primary" sx={{ mr: 1 }} />
//                                                             <Typography variant="body1">
//                                                                 Total Value: ₹{selectedEnquiry.quantity * selectedEnquiry.product.Productprice}
//                                                             </Typography>
//                                                         </Box>
//                                                     }
//                                                 />
//                                             </ListItem>
//                                             <ListItem disableGutters>
//                                                 <ListItemText
//                                                     primary={
//                                                         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                                             <CalendarToday color="primary" sx={{ mr: 1 }} />
//                                                             <Typography variant="body1">
//                                                                 Enquiry Date: {formatDate(selectedEnquiry.createdAt)}
//                                                             </Typography>
//                                                         </Box>
//                                                     }
//                                                 />
//                                             </ListItem>
//                                             <ListItem disableGutters>
//                                                 <ListItemText
//                                                     primary="Message:"
//                                                     secondary={selectedEnquiry.message}
//                                                     secondaryTypographyProps={{ color: 'text.primary' }}
//                                                 />
//                                             </ListItem>
//                                         </List>
//                                         <Divider sx={{ my: 2 }} />
//                                         <Typography variant="subtitle1" gutterBottom>
//                                             Vendor Information
//                                         </Typography>
//                                         <List dense disablePadding>
//                                             <ListItem disableGutters>
//                                                 <ListItemText
//                                                     primary={
//                                                         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                                             <Business color="primary" sx={{ mr: 1 }} />
//                                                             <Typography variant="body1">
//                                                                 {selectedEnquiry.vendor.companyName}
//                                                             </Typography>
//                                                         </Box>
//                                                     }
//                                                     secondary={selectedEnquiry.vendor.registeredAddress}
//                                                 />
//                                             </ListItem>
//                                             <ListItem disableGutters>
//                                                 <ListItemText
//                                                     primary={
//                                                         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                                             <LocalShipping color="primary" sx={{ mr: 1 }} />
//                                                             <Typography variant="body1">
//                                                                 {selectedEnquiry.vendor.country}
//                                                             </Typography>
//                                                         </Box>
//                                                     }
//                                                     secondary={`GSTIN: ${selectedEnquiry.vendor.GSTIN}`}
//                                                 />
//                                             </ListItem>
//                                         </List>
//                                     </CardContent>
//                                 </Card>
//                             </Grid>
//                             <Grid item xs={12}>
//                                 <Typography variant="subtitle1" gutterBottom>
//                                     Update Status
//                                 </Typography>
//                                 <TableContainer component={Paper}>
//                                     <Table>
//                                         <TableHead>
//                                             <TableRow>
//                                                 <TableCell>Status</TableCell>
//                                                 <TableCell>Action</TableCell>
//                                             </TableRow>
//                                         </TableHead>
//                                         <TableBody>
//                                             {statusOptions.map((status) => (
//                                                 <TableRow key={status}>
//                                                     <TableCell>
//                                                         <StatusChip status={status} />
//                                                     </TableCell>
//                                                     <TableCell>
//                                                         <Button
//                                                             variant="outlined"
//                                                             onClick={() => updateEnquiryStatus(selectedEnquiry._id, status)}
//                                                         >
//                                                             Set Status
//                                                         </Button>
//                                                     </TableCell>
//                                                 </TableRow>
//                                             ))}
//                                         </TableBody>
//                                     </Table>
//                                 </TableContainer>
//                             </Grid>
//                         </Grid>
//                     )}
//                 </DialogContent>
//                 <DialogActions sx={{ p: 2, borderTop: '1px solid', borderColor: 'divider' }}>
//                     <Button onClick={handleCloseDialog} variant="outlined">
//                         Close
//                     </Button>
//                 </DialogActions>
//             </Dialog>
//         </Box>
//     );
// }
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Avatar,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Grid,
  Card,
  CardContent,
  CardMedia,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Tooltip,
  TablePagination,
  CircularProgress,
  Select,
  MenuItem,
} from "@mui/material";
import {
  PendingActions,
  CheckCircle,
  Close,
  Email,
  Phone,
  Person,
  Inventory,
  Description,
  Search,
  FilterList,
  Refresh,
  ArrowForward,
  Business,
  LocalShipping,
  AttachMoney,
  CalendarToday,
} from "@mui/icons-material";
import { API_BASE_URL } from "../utils";

export function Enquiries() {
  const [enquiries, setEnquiries] = useState([]);
  const [filteredEnquiries, setFilteredEnquiries] = useState([]);
  const [selectedEnquiry, setSelectedEnquiry] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const statusOptions = ["PENDING", "APPROVED", "REJECTED", "CLOSED"];

  const fetchData = async () => {
    setLoading(true);
    try {
      const header = localStorage.getItem("adminId");
      const headers = { Authorization: `Bearer ${header}` };
      const response = await axios.get(
        `${API_BASE_URL}/admin/vendor/enquiries`,
        { headers }
      );
      if (response.data.success) {
        setEnquiries(response.data.enquiries);
        setFilteredEnquiries(response.data.enquiries);
      }
    } catch (error) {
      console.error("Error fetching enquiries:", error);
    } finally {
      setLoading(false);
    }
  };

  const updateEnquiryStatus = async (enquiryId, newStatus) => {
    setLoading(true);
    try {
      const header = localStorage.getItem("adminId");
      const headers = { Authorization: `Bearer ${header}` };
      const response = await axios.patch(
        `${API_BASE_URL}/admin/vendor/enquiry/${enquiryId}`,
        { status: newStatus },
        { headers }
      );

      if (response.data.success) {
        setEnquiries((prev) =>
          prev.map((enquiry) =>
            enquiry._id === enquiryId
              ? { ...enquiry, status: newStatus }
              : enquiry
          )
        );
        setFilteredEnquiries((prev) =>
          prev.map((enquiry) =>
            enquiry._id === enquiryId
              ? { ...enquiry, status: newStatus }
              : enquiry
          )
        );
      }
    } catch (error) {
      console.error("Error updating enquiry status:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleViewDetails = (enquiry) => {
    setSelectedEnquiry(enquiry);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h5" component="h1" fontWeight="bold">
          Product Enquiry
        </Typography>
        <Tooltip title="Refresh">
          <IconButton onClick={fetchData} color="primary">
            <Refresh />
          </IconButton>
        </Tooltip>
      </Box>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }}>
              <TableHead>
                <TableRow>
                  <TableCell>Product</TableCell>
                  <TableCell>Customer</TableCell>
                  <TableCell align="center">Quantity</TableCell>
                  <TableCell align="center">Vendor Name</TableCell>
                  <TableCell align="center">Vendor Email</TableCell>
                  <TableCell align="center">Date</TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredEnquiries
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((enquiry) => (
                    <TableRow key={enquiry?._id} hover>
                      <TableCell>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Avatar
                            src={
                              enquiry?.product?.productimages[0]?.productimage
                            }
                            variant="rounded"
                            sx={{ width: 40, height: 40, mr: 2 }}
                          />
                          <Box>
                            <Typography fontWeight="500">
                              {enquiry?.product?.product}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Part #: {enquiry?.product?.partNumber}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography>{enquiry?.name}</Typography>
                        <Typography variant="body2" color="text.secondary">
                          {enquiry?.email}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Chip
                          label={enquiry?.quantity}
                          variant="outlined"
                          size="small"
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Chip
                          label={`${enquiry?.vendor?.firstName} ${enquiry?.vendor?.lastName}`}
                          variant="outlined"
                          size="small"
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Chip
                          label={enquiry?.vendor?.email}
                          variant="outlined"
                          size="small"
                        />
                      </TableCell>
                      <TableCell align="center">
                        {formatDate(enquiry?.createdAt)}
                      </TableCell>
                      <TableCell align="center">
                        <Select
                          value={enquiry?.status}
                          onChange={(e) =>
                            updateEnquiryStatus(enquiry?._id, e.target.value)
                          }
                          size="small"
                          sx={{ minWidth: 120 }}
                        >
                          {statusOptions.map((status) => (
                            <MenuItem key={status} value={status}>
                              {status?.charAt(0) +
                                status?.slice(1).toLowerCase()}
                            </MenuItem>
                          ))}
                        </Select>
                      </TableCell>
                      <TableCell align="center">
                        <IconButton onClick={() => handleViewDetails(enquiry)}>
                          <ArrowForward />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredEnquiries.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{ mt: 2 }}
          />
        </>
      )}

      {/* Dialog remains unchanged */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
        scroll="paper"
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid",
            borderColor: "divider",
            pb: 2,
          }}
        >
          <Box>
            <Typography variant="h6">Enquiry Details</Typography>
            <Typography variant="body2" color="text.secondary">
              ID: {selectedEnquiry?._id}
            </Typography>
          </Box>
          {/* <StatusChip status={selectedEnquiry?.status} /> */}
        </DialogTitle>
        <DialogContent dividers>
          {selectedEnquiry && (
            <Grid container spacing={3}>
              {/* Product Information Column */}
              <Grid item xs={12} md={6}>
                <Card variant="outlined" sx={{ mb: 3 }}>
                  <CardMedia
                    component="img"
                    height="200"
                    image={
                      selectedEnquiry.product.productimages[0]?.productimage
                    }
                    alt={selectedEnquiry.product.product}
                    sx={{ objectFit: "contain", p: 2 }}
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h6" component="div">
                      {selectedEnquiry.product.product}
                    </Typography>

                    <Grid container spacing={1} sx={{ mb: 2 }}>
                      <Grid item xs={6}>
                        <Typography variant="body2" color="text.secondary">
                          <Box component="span" fontWeight="fontWeightMedium">
                            Part #:
                          </Box>{" "}
                          {selectedEnquiry.product.partNumber}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2" color="text.secondary">
                          <Box component="span" fontWeight="fontWeightMedium">
                            Manufacturer:
                          </Box>{" "}
                          {selectedEnquiry.product.manufacturer}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2" color="text.secondary">
                          <Box component="span" fontWeight="fontWeightMedium">
                            Available:
                          </Box>{" "}
                          {selectedEnquiry.product.quantity}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2" color="text.secondary">
                          <Box component="span" fontWeight="fontWeightMedium">
                            Price:
                          </Box>{" "}
                          ₹{selectedEnquiry.product.Productprice}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Divider sx={{ my: 2 }} />

                    <Typography variant="subtitle1" gutterBottom>
                      Product Specifications
                    </Typography>
                    <List dense disablePadding>
                      {selectedEnquiry.product.descriptions.map(
                        (desc, index) => (
                          <ListItem key={index} disableGutters>
                            <ListItemText
                              primary={desc.name}
                              secondary={desc.value}
                              primaryTypographyProps={{ variant: "body2" }}
                              secondaryTypographyProps={{
                                variant: "body2",
                                color: "text.primary",
                              }}
                            />
                          </ListItem>
                        )
                      )}
                    </List>
                  </CardContent>
                </Card>
              </Grid>

              {/* Customer and Enquiry Information Column */}
              <Grid item xs={12} md={6}>
                <Card variant="outlined" sx={{ mb: 3 }}>
                  <CardContent>
                    <Typography variant="subtitle1" gutterBottom>
                      Customer Information
                    </Typography>
                    <List dense disablePadding>
                      <ListItem disableGutters>
                        <ListItemText
                          primary={
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Person color="primary" sx={{ mr: 1 }} />
                              <Typography variant="body1">
                                {selectedEnquiry.name}
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItem>
                      <ListItem disableGutters>
                        <ListItemText
                          primary={
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Email color="primary" sx={{ mr: 1 }} />
                              <Typography variant="body1">
                                {selectedEnquiry.email}
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItem>
                      <ListItem disableGutters>
                        <ListItemText
                          primary={
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Phone color="primary" sx={{ mr: 1 }} />
                              <Typography variant="body1">
                                {selectedEnquiry.phone}
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItem>
                    </List>

                    <Divider sx={{ my: 2 }} />

                    <Typography variant="subtitle1" gutterBottom>
                      Enquiry Details
                    </Typography>
                    <List dense disablePadding>
                      <ListItem disableGutters>
                        <ListItemText
                          primary={
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Inventory color="primary" sx={{ mr: 1 }} />
                              <Typography variant="body1">
                                Requested Quantity: {selectedEnquiry.quantity}
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItem>
                      <ListItem disableGutters>
                        <ListItemText
                          primary={
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <AttachMoney color="primary" sx={{ mr: 1 }} />
                              <Typography variant="body1">
                                Total Value: ₹
                                {selectedEnquiry.quantity *
                                  selectedEnquiry.product.Productprice}
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItem>
                      <ListItem disableGutters>
                        <ListItemText
                          primary={
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <CalendarToday color="primary" sx={{ mr: 1 }} />
                              <Typography variant="body1">
                                Enquiry Date:{" "}
                                {formatDate(selectedEnquiry.createdAt)}
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItem>
                      <ListItem disableGutters>
                        <ListItemText
                          primary="Message:"
                          secondary={selectedEnquiry.message}
                          secondaryTypographyProps={{ color: "text.primary" }}
                        />
                      </ListItem>
                    </List>

                    <Divider sx={{ my: 2 }} />

                    <Typography variant="subtitle1" gutterBottom>
                      Vendor Information
                    </Typography>
                    <List dense disablePadding>
                      <ListItem disableGutters>
                        <ListItemText
                          primary={
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Business color="primary" sx={{ mr: 1 }} />
                              <Typography variant="body1">
                                {selectedEnquiry.vendor.companyName}
                              </Typography>
                            </Box>
                          }
                          secondary={selectedEnquiry.vendor.registeredAddress}
                        />
                      </ListItem>
                      <ListItem disableGutters>
                        <ListItemText
                          primary={
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <LocalShipping color="primary" sx={{ mr: 1 }} />
                              <Typography variant="body1">
                                {selectedEnquiry.vendor.country}
                              </Typography>
                            </Box>
                          }
                          secondary={`GSTIN: ${selectedEnquiry.vendor.GSTIN}`}
                        />
                      </ListItem>
                    </List>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions
          sx={{ p: 2, borderTop: "1px solid", borderColor: "divider" }}
        >
          <Button onClick={handleCloseDialog} variant="outlined">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
